/**
 * Dashboard principal.
 *
 * Layout Fynix ativo por padrão (USE_FYNIX_DASHBOARD = true).
 * Para restaurar o visual antigo:
 *   1. Em dashboardLayoutFlag.ts → USE_FYNIX_DASHBOARD = false
 *   ou
 *   2. Use o arquivo Dashboard.legacy.tsx como referência / cópia.
 */
import { USE_FYNIX_DASHBOARD } from "@/components/dashboardLayoutFlag";
import { DashboardFynix } from "@/components/Dashboard.fynix";
import { DashboardLegacy } from "@/components/Dashboard.legacy";

export function Dashboard() {
  return USE_FYNIX_DASHBOARD ? <DashboardFynix /> : <DashboardLegacy />;
}
